import { useAccountContext } from '@apeiron/temp'
import { Box, styled } from '@mui/material'
import VipPassBanner from '@src/components/battle/demo/vip-pass/VipPassBanner'
import VipPassConnectWalletSection from '@src/components/battle/demo/vip-pass/VipPassConnectWalletSection'
import VipPassDrawHistory from '@src/components/battle/demo/vip-pass/VipPassDrawHistory'
import VipPassInfoSection from '@src/components/battle/demo/vip-pass/VipPassInfoSection'
import VipPassLootBoxSection from '@src/components/battle/demo/vip-pass/VipPassLootBoxSection'
import VipPassRewardSection from '@src/components/battle/demo/vip-pass/VipPassRewardSection'

const MainContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const MainSection = styled(Box)`
  display: flex;
  flex-direction: column;

  gap: 20px;

  margin: 10px;

  ${props => props.theme.breakpoints.up('res1024')} {
    width: 1000px;
  }

  ${props => props.theme.breakpoints.down('res1024')} {
    width: 95%;
  }
`

const VipPass = () => {
  const { isWalletConnected } = useAccountContext()

  return (
    <MainContainer>
      <VipPassBanner />

      <MainSection>
        <VipPassLootBoxSection />

        <VipPassInfoSection />

        <VipPassRewardSection />

        <VipPassDrawHistory />

        {!isWalletConnected && <VipPassConnectWalletSection />}
      </MainSection>
    </MainContainer>
  )
}

export default VipPass
